module.exports = __webpack_public_path__ + "static/media/Affiliate-BG_desktop_Euro.934c30a6.webp";